let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e9f9y")).then(() => parcelRequire('bTxkC'));